import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { devLog } from '../lib/uiHelpers';

const backendUrl = process.env.REACT_APP_BACKEND_URL || '';

const resolveUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${backendUrl}${url}`;
};

const AdBanner = ({ position = 'homepage', className = '' }) => {
  const [ads, setAds] = useState([]);
  const [broken, setBroken] = useState({});

  const fetchAds = useCallback(async () => {
    try {
      const res = await api.get(`/advertisements/public?position=${encodeURIComponent(position)}`);
      setAds(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      devLog(err);
      setAds([]);
    }
  }, [position]);

  useEffect(() => {
    fetchAds();
  }, [fetchAds]);

  if (!ads.length) return null;

  return (
    <div className={className} data-testid={`ad-banner-${position}`}>
      {ads.map((ad) => {
        if (broken[ad.id]) return null;
        const src = resolveUrl(ad.image);
        if (!src) return null;
        const img = (
          <img
            src={src}
            alt={ad.title || 'Advertisement'}
            className="w-full h-auto object-cover border-2 border-border"
            loading="lazy"
            data-testid={`public-ad-${ad.id}`}
            onError={() => setBroken((prev) => ({ ...prev, [ad.id]: true }))}
          />
        );
        if (ad.link) {
          return (
            <a
              key={ad.id}
              href={ad.link}
              target={ad.target || '_blank'}
              rel={ad.target === '_self' ? undefined : 'noopener noreferrer'}
              className="block mb-4 last:mb-0"
              data-testid={`public-ad-link-${ad.id}`}
            >
              {img}
            </a>
          );
        }
        return (
          <div key={ad.id} className="mb-4 last:mb-0" data-testid={`public-ad-wrap-${ad.id}`}>
            {img}
          </div>
        );
      })}
    </div>
  );
};

export default AdBanner;
